<script setup lang="ts">
import MobileAppShell from '@/app/MobileAppShell.vue'
</script>

<template>
  <MobileAppShell />
</template>
